<!-- Outer root container -->
<ac-container width="fill" height="fill">
	<!-- FeatureFlags -->
	<ac-container width="fill" height="fill" gap-vertical="16" padding-horizontal="16" padding-vertical="16" auto-layout="vertical" [visible]="model.featureFlagsUIVisible">
		<!-- Topbar Container -->
		<ac-container width="fill" alignment="center" gap-horizontal="auto">
			<!-- Icon Header Container -->
			<ac-container alignment="center" gap-horizontal="8">
				<ac-icon name="flag-01"></ac-icon>
				<ac-label [text]="'setup.sidebar.featureflagsadmin' | translate" variant="dark" size="large"></ac-label>
			</ac-container>
		</ac-container>
		<!-- Main section -->
		<ac-container width="fill" height="fill" gap-horizontal="16">
			<!-- Services -->
			<ac-container fill="#F5F7FA" width="fill" height="fill" padding-horizontal="16" padding-vertical="16" gap-vertical="8" corner-radius="8" auto-layout="vertical">
				<ac-label variant="dark" size="large" [text]="'setup.featureflagsadmin.services' | translate"></ac-label>
				<!-- Services list stroke container -->
				<ac-stroke-container width="fill" height="fill" corner-radius="8" padding-horizontal="8" padding-vertical="8">
					<!-- Services List -->
					<ac-html-select-list width="fill" height="fill" auto-layout="vertical" gap-vertical="4" (HTMLSelectListEvent.selectionChanged)="controller.serviceSelectionChanged($event)">
						@for (service of model.services; track service) {
							<ac-html-select-list-item-renderer [payload]="service" width="fill" height="32" alignment="left" padding-horizontal="10" corner-radius="6" cursor="pointer">
								<ac-label [text]="service.name"></ac-label>
							</ac-html-select-list-item-renderer>
						}
					</ac-html-select-list>
				</ac-stroke-container>
			</ac-container>
			<!-- Flags -->
			<ac-container fill="#F5F7FA" width="fill" height="fill" padding-horizontal="16" padding-vertical="16" gap-vertical="8" corner-radius="8" auto-layout="vertical">
				<ac-label variant="dark" size="large" [text]="'setup.featureflagsadmin.flags' | translate"></ac-label>
				<!-- Flags List -->
				<ac-html-select-list (HTMLSelectListEvent.selectionChanged)="controller.flagsController.flagSelectedChanged($event)" (CheckBoxEvent.selectedChanged)="controller.enabledChanged($event)" width="fill" height="fill" auto-layout="vertical" gap-vertical="8" clip-content="true" hide-scrollbars="true">
					@for (flag of model.selectedService?.flags; track flag) {
						<ac-flag-list-item-renderer [payload]="flag">
							<ac-container width="fill" gap-horizontal="16" alignment="left">
								<ac-label width="fill" variant="dark" size="large" [text]="flag.name"></ac-label>
								<ac-check-box [selected]="flag.enabled" [item]="flag"></ac-check-box>
							</ac-container>
							<ac-label width="fill" [text]="flag.description"></ac-label>
							<ac-container width="fill" gap-horizontal="16">
								<ac-label width="fill" [text]="'setup.featureflagsadmin.created' | translate" variant="light"></ac-label>
								<ac-label [text]="model.toDateString(flag.createdAt)"></ac-label>
							</ac-container>
							<ac-container width="fill" gap-horizontal="16" alignment="center" [visible]="!flag.enabled">
								<ac-label width="fill" [text]="'setup.featureflagsadmin.turnsOn' | translate" variant="light"></ac-label>
								<ac-button icon="edit-02" [text]="'setup.featureflagsadmin.changeDate' | translate" (click)="$event.stopPropagation()" (ButtonEvent.clicked)="model.showEditDateDialog(flag)"></ac-button>
								<ac-label [text]="model.toDateString(flag.expiresAt)"></ac-label>
							</ac-container>
							<ac-container width="fill" gap-horizontal="16" [visible]="!flag.enabled">
								<ac-label width="fill" [text]="'setup.featureflagsadmin.activates' | translate" variant="light"></ac-label>
								<ac-label [text]="model.toDaysLeft(flag.expiresAt) + ' ' + ('setup.featureflagsadmin.days' | translate)"></ac-label>
							</ac-container>
						</ac-flag-list-item-renderer>
					}
				</ac-html-select-list>
			</ac-container>
			<!-- Variants -->
			<ac-container fill="#F5F7FA" width="fill" height="fill" padding-horizontal="16" padding-vertical="16" gap-vertical="8" corner-radius="8" auto-layout="vertical">
				<ac-container width="fill" gap-horizontal="auto">
					<ac-label variant="dark" size="large" [text]="'setup.featureflagsadmin.variants' | translate"></ac-label>
					<ac-button icon="dataflow-01" [text]="'setup.featureflagsadmin.addVariants' | translate" (ButtonEvent.clicked)="model.showAddVariantsDialog()" [enabled]="model.addVariantsTopLevelButtonEnabled"></ac-button>
				</ac-container>
				<!-- Variants List -->
				<ac-container gap-vertical="8" auto-layout="vertical" width="fill" height="fill" clip-content="true" hide-scrollbars="true" (CheckBoxEvent.selectedChanged)="controller.enabledChanged($event)">
					@for (organizationVariant of model.organizationVariants; track organizationVariant) {
						<ac-stroke-container width="fill" height="hug" auto-layout="vertical" padding-vertical="12" gap-vertical="8" corner-radius="8">
							<ac-label width="fill" size="large" variant="dark" [text]="organizationVariant.organization.name"></ac-label>
							@for (variant of organizationVariant.variants; track variant) {
								<ac-container width="fill" height="20" alignment="left" gap-horizontal="16">
									<ac-label [text]="variant.account.name" variant="light" width="fill"></ac-label>
									<ac-check-box [selected]="variant.enabled" [item]="variant"></ac-check-box>
								</ac-container>
							}
						</ac-stroke-container>
					}
				</ac-container>
			</ac-container>
		</ac-container>
	</ac-container>
	<ac-spinner-overlay [visible]="model.globalSpinnerVisible"></ac-spinner-overlay>
</ac-container>

<!-- Confirmation Dialog -->
<dialog #confirmationDialog closedby="none">
	<ac-stroke-container width="400" height="hug" padding-horizontal="0" padding-vertical="0" clip-content="true" hide-scrollbars="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="flag-01"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.confirmHeader' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container width="fill" padding-horizontal="16" padding-vertical="16">
			<ac-label width="fill" truncate="false" [text]="model.confirmBody"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="controller.flagsController.hideConfirmationDialog()" [enabled]="!model.updatingFlags" icon="x-close" [text]="'setup.featureflagsadmin.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.flagsController.confirmationSave()" [enabled]="!model.updatingFlags" icon="check-circle" [text]="'setup.featureflagsadmin.continue' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Edit Date Dialog -->
<dialog #editDateDialog closedby="none" [attr.aria-label]="'setup.featureflagsadmin.changeDateHeader' | translate">
	<ac-stroke-container width="400" height="hug" padding-horizontal="0" padding-vertical="0" clip-content="true" hide-scrollbars="true">
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="flag-01"></ac-icon>
			</ac-stroke-container>
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.changeDateHeader' | translate"></ac-label>
		</ac-container>
		<ac-divider></ac-divider>
		<ac-container width="fill" padding-horizontal="16" padding-vertical="16" auto-layout="vertical" gap-vertical="8">
			<ac-label width="fill" truncate="false" [text]="'setup.featureflagsadmin.changeDateBody' | translate: { name: model.editingFlag?.name ?? '' }"></ac-label>
			@if (model.editDateOpen) {
				<input class="date-input" type="date" [attr.aria-label]="'setup.featureflagsadmin.turnsOn' | translate" [min]="model.editDateMin" [value]="model.editDateInitial" (input)="model.editDateValue = $any($event.target).value" />
			}
		</ac-container>
		<ac-divider></ac-divider>
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="model.hideEditDateDialog()" [enabled]="!model.updatingFlags" icon="x-close" [text]="'setup.featureflagsadmin.cancel' | translate"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.flagsController.saveExpiresAt()" [enabled]="!model.updatingFlags && model.editDateSavable" icon="check-circle" [text]="'setup.featureflagsadmin.save' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Network Error Dialog -->
<dialog #networkErrorDialog closedby="none">
	<ac-stroke-container width="360" height="hug" padding-horizontal="0" padding-vertical="0" clip-content="true" hide-scrollbars="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="alert-circle"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.noConnection' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container width="fill" alignment="left" padding-horizontal="16" padding-vertical="16">
			<ac-label width="fill" truncate="false" [text]="'setup.featureflagsadmin.networkError' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="model.hideNetworkErrorDialog()" icon="x-close" [text]="'setup.featureflagsadmin.close' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Unknown Error Dialog -->
<dialog #unknownErrorDialog closedby="none">
	<ac-stroke-container width="360" height="hug" padding-horizontal="0" padding-vertical="0" clip-content="true" hide-scrollbars="true">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="alert-circle"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.unknownErrorLabel' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<ac-container width="fill" padding-horizontal="16" padding-vertical="16">
			<ac-label width="fill" truncate="false" [text]="'setup.featureflagsadmin.unknownError' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="model.hideUnknownErrorDialog()" icon="x-close" [text]="'setup.featureflagsadmin.close' | translate"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>

<!-- Add Variants Dialog -->
<dialog #addVariantsDialog closedby="none">
	<ac-stroke-container width="768" height="512" padding-horizontal="0" padding-vertical="0">
		<!-- Top Bar -->
		<ac-container padding-horizontal="16" padding-vertical="16" gap-horizontal="16" alignment="left">
			<!-- Icon Ring -->
			<ac-stroke-container width="40" height="40" corner-radius="20" alignment="center" padding-horizontal="0" padding-vertical="0">
				<ac-icon name="dataflow-01"></ac-icon>
			</ac-stroke-container>
			<!-- Label -->
			<ac-label variant="dark" [text]="'setup.featureflagsadmin.addVariants' | translate"></ac-label>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Content -->
		<ac-container width="fill" height="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="16">
			<!-- Organizations -->
			<ac-container width="fill" height="fill" auto-layout="vertical" gap-vertical="8">
				<ac-label [text]="'setup.featureflagsadmin.organizations' | translate" width="fill" variant="dark" size="medium"></ac-label>
				<ac-name-select-list (SelectListEvent.selectionChanged)="controller.variantsController.organizationSelectionChange($event)" [data]="model.organizations"></ac-name-select-list>
			</ac-container>
			<!-- Vertical Divider -->
			<ac-divider width="1" height="fill"></ac-divider>
			<!-- Accounts -->
			<ac-container width="fill" height="fill" auto-layout="vertical" gap-vertical="8">
				<ac-label [text]="'setup.featureflagsadmin.accounts' | translate" width="fill" variant="dark" size="medium"></ac-label>
				<ac-name-select-list (SelectListEvent.selectionChanged)="controller.variantsController.accountSelectionChange($event)" [data]="model.organizationAccounts" [allowMultiSelect]="true"></ac-name-select-list>
			</ac-container>
			<ac-spinner-overlay [visible]="model.addVariantsSpinnerVisible"></ac-spinner-overlay>
		</ac-container>
		<!-- Divider -->
		<ac-divider></ac-divider>
		<!-- Bottom Bar -->
		<ac-container alignment="right" width="fill" padding-horizontal="16" padding-vertical="16" gap-horizontal="10">
			<ac-button (ButtonEvent.clicked)="model.hideAddVariantsDialog()" icon="x-close" [text]="'setup.featureflagsadmin.close' | translate" [enabled]="model.addVariantsCancelButtonEnabled"></ac-button>
			<ac-button (ButtonEvent.clicked)="controller.variantsController.addVariantsButtonClicked()" icon="check-circle" [text]="'setup.featureflagsadmin.addSelected' | translate" [enabled]="model.addVariantsButtonEnabled"></ac-button>
		</ac-container>
	</ac-stroke-container>
</dialog>
